import React from 'react';
import { NavLink } from 'react-router-dom';
import queryString from 'query-string';
import classNames from 'classnames';
import styles from './NavTabs.module.scss';

interface NavTabProps {
  tabs: any;
}

export const NavTabs: React.FC<NavTabProps> = ({ tabs }) => {
  let stretch = true;

  return (
    <div className={styles.container}>
      {tabs.map((tab: any) => {
        const {
          className,
          defaultTab = false,
          key,
          label,
          lesserTab = false,
          spacer = false,
          to,
        } = tab;

        if (spacer) {
          stretch = false;

          return <div key="spacer" className={styles.stretch} />;
        }

        const lesserTabClass = lesserTab ? styles.lesserTab : '';
        const classes = [styles[`${className}`]];

        return (
          <NavLink
            activeClassName={styles.active}
            className={classNames(classes, lesserTabClass, styles.tab)}
            exact
            isActive={(match, location) => {
              const params = queryString.parse(location.search);
              return params.tab ? params.tab === key : defaultTab;
            }}
            key={to}
            to={to}
          >
            {label}
          </NavLink>
        );
      })}

      {stretch && <div className={styles.stretch} />}
    </div>
  );
};
